import React, { useContext, useEffect, useState } from 'react';
import { useStateInRef } from 'seagull';
const GoogleMapsContext = /*#__PURE__*/React.createContext(undefined);
export const useGoogleMaps = () => useContext(GoogleMapsContext);
export default function GoogleMapsProvider(props) {
  const getProps = useStateInRef(props);
  const [googleMaps, setGoogleMaps] = useState();
  useEffect(() => {
    getProps().loadGoogleMaps().then(setGoogleMaps);
  }, []);
  return /*#__PURE__*/React.createElement(GoogleMapsContext.Provider, {
    value: googleMaps
  }, props.children);
}